import Box from '@mui/material/Box'

import { useConciergeList } from '@/hooks/useConciergeList'
import { CONCIERGE_TYPES } from '@/store/constant'
import { useAuth } from '@hooks/useAuth'
import menuLinks from './MenuLinks'
import NavGroup from './NavGroup'

function MenuList() {
  const { isAdmin } = useAuth()
  const { conciergeType } = useConciergeList()

  const isVenue = conciergeType === CONCIERGE_TYPES.BOOKING_LOVE

  const filteredMenuItems = menuLinks.items.filter((item) => {
    if ((item.id === 'adminDashboard' || item.id === 'feedback') && !isAdmin)
      return false
    if (item.id === 'venue' && !isVenue) return false
    return true
  })

  const navItems = filteredMenuItems.map((item) => {
    return <NavGroup key={item.id} item={item} />
  })

  return <Box>{navItems}</Box>
}

export default MenuList
